// extracted by css-extract-rspack-plugin
export default {"regulatoryComplianceToggle":"BVeHegoqs88V0Qvk","toggle":"klS_YpUr7ZwMMKcE","label":"oUVsxtnls4pmDJ7h","description":"_3tDqCxTSY4dohcn"};